// #region Imports
import React, { useState, useMemo } from 'react';
import './NovaVendaSection.scss';
import { formatCurrency } from '../../../../shared/helpers';
import boxIcon from '../../../assets/caixaIcon.svg';
import cartIcon from '../../../assets/vendasIcon.svg';
import searchIcon from '../../../assets/lupa.svg';
import trashIcon from '../../../assets/trash.svg';
// #endregion

export default function NovaVendaSection({
  produtos = [],
  servicos = [],
  funcionarios = [],
  cart = [],
  onAddProduto,
  onAddServico,
  onRemoveItem,
  onUpdateQtd,
  total,
}) {
  // #region Estado
  const [tab, setTab] = useState('PRODUTOS');
  const [servFuncionario, setServFuncionario] = useState('');
  // #endregion

  // #region Derivados
  const { totalProdutos, totalServicos } = useMemo(() => {
    let tp = 0; let ts = 0;
    cart.forEach(i => {
      const val = i.preco_unit * i.quantidade;
      if (i.tipo === 'PRODUTO') tp += val; else if (i.tipo === 'SERVICO') ts += val;
    });
    return { totalProdutos: tp, totalServicos: ts };
  }, [cart]);
  // #endregion

  // #region Render
  return (
    <div className="nova-venda-grid">
      {/* Coluna Adicionar Itens */}
      <div className="add-itens-card">
        <div className="card-head">
          <div className="title-ico">
            <img src={boxIcon} alt="Adicionar" />
            <h3>Adicionar Itens</h3>
          </div>
          <div className="search-wrapper">
            <img src={searchIcon} alt="Buscar" className="ico" />
            <input className="search" placeholder="Buscar produtos ou serviços..." disabled />
          </div>
        </div>
        <div className="subtabs refined">
          <button
            className={tab === 'PRODUTOS' ? 'active' : ''}
            onClick={() => setTab('PRODUTOS')}
          >
            Produtos
          </button>
          <button
            className={tab === 'SERVICOS' ? 'active' : ''}
            onClick={() => setTab('SERVICOS')}
          >
            Serviços
          </button>
          <span className="indicator" data-tab={tab} />
        </div>
        {tab === 'SERVICOS' && (
          <div className="serv-func-select">
            <select
              value={servFuncionario}
              onChange={e => setServFuncionario(e.target.value)}
            >
              <option value="">Selecione o funcionário</option>
              {funcionarios.map(f => (
                <option key={f.id} value={f.id}>
                  {f.nome} - {f.cargo}
                </option>
              ))}
            </select>
          </div>
        )}
        <div className="itens-grid">
          {tab === 'PRODUTOS' &&
            produtos.map(p => (
              <div key={p.id} className="item-card">
                <div className="stock-badge">{p.estoque_atual ?? 0} un</div>
                <div className="item-main">
                  <span className="title">{p.nome}</span>
                  {p.marca && <span className="sub">{p.marca}</span>}
                </div>
                <div className="price">{formatCurrency(p.preco_venda)}</div>
                <button
                  type="button"
                  className="add-btn"
                  onClick={() => onAddProduto(p)}
                  aria-label="Adicionar produto"
                >
                  +
                </button>
              </div>
            ))}
          {tab === 'SERVICOS' &&
            servicos.map(s => (
              <div key={s.id} className="item-card">
                <div className="stock-badge svc">{s.perc_comissao_padrao || 0}%</div>
                <div className="item-main">
                  <span className="title">{s.nome}</span>
                  {s.categoria && <span className="sub">{s.categoria}</span>}
                </div>
                <div className="price">{formatCurrency(s.preco_padrao)}</div>
                <button
                  type="button"
                  className="add-btn"
                  disabled={!servFuncionario}
                  onClick={() => onAddServico(s, Number(servFuncionario))}
                  aria-label="Adicionar serviço"
                >
                  +
                </button>
              </div>
            ))}
        </div>
      </div>

      {/* Coluna Carrinho */}
      <div className="carrinho-card">
        <div className="carrinho-head">
          <div className="title-ico">
            <img src={cartIcon} alt="Carrinho" />
            <h3>Carrinho ({cart.length})</h3>
          </div>
        </div>
        <div className="carrinho-body">
          {cart.length === 0 && <div className="empty">Carrinho vazio</div>}
          {cart.length > 0 && (
            <div className="carrinho-scroll" aria-label="Itens do carrinho" role="list">
              {cart.map((it, idx) => (
                <div key={idx} className="cart-item" role="listitem">
                  <div className="ci-main">
                    <span className="ci-title">{it.nome}</span>
                    {it.tipo === 'SERVICO' && <span className="ci-sub">Serviço</span>}
                  </div>
                  <div className="ci-actions">
                    <div className="qtd" aria-label="Quantidade">
                      <button onClick={() => onUpdateQtd(idx, -1)} aria-label="Diminuir">-</button>
                      <input value={it.quantidade} readOnly aria-label="Quantidade atual" />
                      <button onClick={() => onUpdateQtd(idx, 1)} aria-label="Aumentar">+</button>
                    </div>
                    <span className="ci-price">{formatCurrency(it.preco_unit * it.quantidade)}</span>
                    <button
                      className="remove"
                      onClick={() => onRemoveItem(idx)}
                      aria-label="Remover item"
                    >
                      <img src={trashIcon} alt="" className="ico-trash" />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        {cart.length > 0 && (
          <div className="carrinho-footer">
            <div className="tot-inline" aria-label="Totais parciais">
              <div className="chip"><span>Produtos</span><strong>{formatCurrency(totalProdutos)}</strong></div>
              <div className="chip"><span>Serviços</span><strong>{formatCurrency(totalServicos)}</strong></div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
  // #endregion
}
